<template>
  <section class="hero-banner-area">
    <div class="hero-banner-container">
      <swiper ref="heroBanner" :options="swiperOption">
        <swiper-slide
          v-for="(slide, index) in slides"
          :key="index"
        >
          <a :href="`${slide.link}${queryString ? '?' + queryString : ''}`">
            <img :src="`${imageUrl}/${slide.image}`" alt="pic"/>
          </a>
        </swiper-slide>
        <div class="swiper-button-next" slot="button-next"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
      </swiper>
    </div>
    <!-- 將 pagination 移到 swiper 外部 -->
    <div class="custom-pagination">
      <span
        v-for="(slide, index) in slides"
        :key="index"
        :class="['pagination-bullet', { 'active': currentSlide === index }]"
        @click="goToSlide(index)"
      ></span>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'

export default {
  name: 'Banner',
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  props: {
    slides: {
      type: Array,
      default: () => []
    },
    imageUrl: {
      type: String,
      required: true
    },
    queryString: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentSlide: 0,
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 4500,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  methods: {
    goToSlide(index) {
      if (this.$refs.heroBanner && this.$refs.heroBanner.$swiper) {
        this.$refs.heroBanner.$swiper.slideTo(index)
        this.currentSlide = index
      }
    }
  },
  mounted() {
    // 確保初始狀態正確並綁定事件
    this.$nextTick(() => {
      if (this.$refs.heroBanner && this.$refs.heroBanner.$swiper) {
        const swiper = this.$refs.heroBanner.$swiper
        this.currentSlide = swiper.activeIndex

        // 綁定 slideChange 事件
        swiper.on('slideChange', () => {
          this.currentSlide = swiper.activeIndex
        })
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.hero-banner-area {
  position: relative;
  width: 100%;
  height: auto; /* 改為自動高度 */
  margin-bottom: 20px;
  background-color: #1c1c1c;
  padding-bottom: 60px; /* 添加底部內邊距為 pagination 留空間 */

  .hero-banner-container {
    width: 100%;
    height: 300px; /* 固定 banner 圖片高度 */
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
    overflow: visible; /* 確保 pagination 可見 */

    .swiper-container {
      border-radius: 12px;
      overflow: hidden;
      background-color: #1c1c1c;
      height: 100%;
    }

    .swiper-slide {
      height: 100%;

      a {
        display: block;
        height: 100%;
        text-decoration: none;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      color: #fff;
      background: rgba(0, 0, 0, 0.3);
      width: 40px;
      height: 40px;
      border-radius: 50%;

      &:hover {
        background: rgba(0, 0, 0, 0.5);
      }

      &::after {
        font-size: 20px;
      }
    }


  }

  // 自定義 pagination 樣式
  .custom-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    height: 20px;

    .pagination-bullet {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin: 0 6px;
      cursor: pointer;
      transition: all 0.3s ease;
      display: inline-block;

      // 第一個指示點 - 粉色
      &:nth-child(1) {
        background: #ff69b4;
      }

      // 第二個指示點 - 藍色
      &:nth-child(2) {
        background: #4169e1;
      }

      // 第三個指示點 - 青色
      &:nth-child(3) {
        background: #00bcd4;
      }

      // 第四個指示點 - 綠色
      &:nth-child(4) {
        background: #4caf50;
      }

      // 第五個指示點 - 黃色
      &:nth-child(5) {
        background: #ffeb3b;
      }

      // 第六個指示點 - 橙色
      &:nth-child(6) {
        background: #ff9800;
      }

      // 如果沒有匹配到顏色，使用白色
      &:nth-child(n+7) {
        background: #fff;
      }

      // 活動狀態
      &.active {
        transform: scale(1.3);
        box-shadow: 0 0 10px currentColor;
        filter: brightness(1.2);
      }

      // hover 效果
      &:hover {
        transform: scale(1.1);
        filter: brightness(1.1);
      }
    }
  }
}

@media (max-width: 768px) {
  .hero-banner-area {
    padding-bottom: 50px; /* 調整平板的底部內邊距 */

    .hero-banner-container {
      height: 200px; /* 平板的 banner 高度 */
      padding: 0 10px;
    }
  }
}

@media (max-width: 480px) {
  .hero-banner-area {
    margin-top: 16px;
    padding-bottom: 45px; /* 調整手機版的底部內邊距 */

    .hero-banner-container {
      height: 180px; /* 手機版的 banner 高度 */
      padding: 0 8px;
    }
  }
}
</style>